import {useTranslation} from "react-i18next";
import {EetsDevice, EetsDeviceField, LeoArticleField, ReasonField} from "../../../app/api/model/eetsDevice";
import LabeledSection from "../../../components/Layout/Page/LabeledSection";
import LabeledValue from "../../../components/Layout/Page/LabeledValue";
import {EMPTY_UI} from "../../../variables";
import React from "react";
import {formatTimestamp} from "../../../utils/datetime";
import PLSentSection from "../../devices/components/PLSentSection";
import {DeviceField} from "../../../app/api/model/device";

export interface EetsDeviceGeneralContentProps {
    eetsDevice: EetsDevice;
}

export default function EetsDeviceGeneralContent({eetsDevice}: EetsDeviceGeneralContentProps) {
    const {t} = useTranslation();

    return (
        <>
            <LabeledSection title={t("generic_general")}>
                <LabeledValue label={t("eets_leoId")} content={eetsDevice?.[EetsDeviceField.LEO_ID]} />
                <LabeledValue
                    label={t("eets_leoArticle")}
                    content={eetsDevice?.[EetsDeviceField.LEO_ART]?.[LeoArticleField.DESCRIPTION]}
                />
                <LabeledValue
                    label={t("organizations_dkvCustomerNumber")}
                    content={eetsDevice?.[EetsDeviceField.DKV_CUSTOMER_NUMBER]}
                />

                <LabeledValue label={t("eets_obuId")} content={eetsDevice?.[EetsDeviceField.OBU_ID]} />
                <LabeledValue label={t("dkvCustomerNumber_t4eId")} content={eetsDevice?.[EetsDeviceField.T4E_ID]} />
                <LabeledValue label={t("eets_vin")} content={eetsDevice?.[EetsDeviceField.VIN]} />
                <LabeledValue label={t("eets_licensePlate")} content={eetsDevice?.[EetsDeviceField.LICENSE_PLATE]} />
            </LabeledSection>
            {eetsDevice?.[EetsDeviceField.LOCK_REASON] && (
                <LabeledSection title={t("generic_lock")} xs={12} md={6}>
                    <LabeledValue
                        label={t("generic_lockedAt")}
                        content={formatTimestamp(eetsDevice?.[EetsDeviceField.LOCKED_AT])}
                    />
                    <LabeledValue
                        label={t("generic_lockReason")}
                        content={eetsDevice?.[EetsDeviceField.LOCK_REASON]?.[ReasonField.DESCRIPTION] || EMPTY_UI}
                    />
                </LabeledSection>
            )}
            {eetsDevice?.[EetsDeviceField.CANCEL_REASON] && (
                <LabeledSection title={t("generic_cancellation")} xs={12} md={6}>
                    <LabeledValue
                        label={t("eetsDevice_canceledAt")}
                        content={formatTimestamp(eetsDevice?.[EetsDeviceField.CANCELED_AT])}
                    />
                    <LabeledValue
                        label={t("generic_cancelReason")}
                        content={eetsDevice[EetsDeviceField.CANCEL_REASON]?.[ReasonField.DESCRIPTION] || EMPTY_UI}
                    />
                </LabeledSection>
            )}
            {eetsDevice && (
                <PLSentSection
                    plSentId={eetsDevice[DeviceField.PL_SENT_ID]}
                    plSentStatus={eetsDevice[DeviceField.PL_SENT_STATUS]}
                    leoId={eetsDevice[EetsDeviceField.LEO_ID]}
                />
            )}
        </>
    );
}
